import { render, staticRenderFns } from "./PageSection.vue?vue&type=template&id=20957c51&scoped=true&"
import script from "./PageSection.vue?vue&type=script&lang=js&"
export * from "./PageSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20957c51",
  null
  
)

export default component.exports